import firebase from 'firebase/app';

export async function loadCheckinData(people, dates, company) {
   let loadedPeople = [];
   await Promise.all(
      people.map(async (person) => {
         await firebase
            .firestore()
            .collection(`company/${company.cid}/people/${person.uid}/schedule`)
            .where(firebase.firestore.FieldPath.documentId(), '>=', dates[0])
            .where(
               firebase.firestore.FieldPath.documentId(),
               '<=',
               dates[dates.length - 1],
            )
            .get()
            .then((results) => {
               if (!results.empty) {
                  results.forEach(async (result) => {
                     if (result.data().checkInOutLog) {
                        const logArr = result.data().checkInOutLog;
                        logArr.forEach(async (dbLog) => {
                           let log = { ...person };
                           log.action = dbLog.checkedIn ? 'IN' : 'OUT';
                           const timestamp = dbLog.checkedIn
                              ? dbLog.checkedInTime
                              : dbLog.checkedOutTime;
                           if (timestamp && timestamp.toDate) {
                              const dateObj = timestamp.toDate();
                              const hours = String(dateObj.getHours()).padStart(2, '0');
                              const minutes = String(dateObj.getMinutes()).padStart(
                                 2,
                                 '0',
                              );
                              log.time = `${hours}:${minutes}`;
                           } else {
                              log.time = '';
                           }
                           log.location = dbLog.checkedIn
                              ? company.locations[dbLog.checkedInTo]
                              : company.locations[dbLog.checkedOutTo];

                           const id = result.id;
                           const month = String(Number(id.slice(4, 6)) + 1).padStart(
                              2,
                              '0',
                           );
                           log.date = `${id.slice(6, 8)}/${month}/${id.slice(2, 4)}`;
                           loadedPeople.push(log);
                        });
                     }
                  });
               }
            });
      }),
   );

   return loadedPeople;
}
